import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {BlockComponentCollection, BlockComponentProps, RequestBlocksFn, RenderBlockArgsCollection} from './types';

export default class ClientReactBlockRenderer {
    protected virtualRoot: HTMLElement;
    protected blocks: RenderBlockArgsCollection = {};
    protected updateApp: () => void;

    constructor(
        protected blockComponents: BlockComponentCollection
    ) {
        this.virtualRoot = document.createElement('div');
        ReactDOM.render(
            <App requestBlocks={this.sendBlocks} setUpdate={this.setUpdate} />,
            this.virtualRoot
        );
    }

    public sendBlocks: RequestBlocksFn = () => {
        return this.blocks;
    }

    public setUpdate = (fn: () => void) => {
        this.updateApp = fn;
    }

    public renderBlock(domElement: Element, blockName: string, props: BlockComponentProps) {
        if (!this.blockComponents[blockName]) {
            throw new Error(
                'Attempt to render unregistered block name: ' + blockName
            );
        }
        this.blocks[domElement.id] = {
            Block: this.blockComponents[blockName],
            props,
        };
        this.updateApp();
    }
}
